<lib-svg-sprite/>

<lib-feature-nav [navButtons]="extraNavButtons"/>

@if (isLoading()) {
<lib-loader/>
} @else if (isDataReady()){
<router-outlet></router-outlet>
}

<lib-feature-consent/>
